import { Action } from '../../common/actions/core/action';
import { ListeningPackageSegment } from '../../common/services/package/package.model';

export class BuySuccessAction implements Action {
  constructor(
    public type:ListeningPackageSegment
  ) {}
}



// WEBPACK FOOTER //
// src/app/buy/buy-success-dialog/buy-success-dialog.action.ts